module.exports = __webpack_public_path__ + "static/media/Freezone Image SF 11263-1 & 11109-2.8d4fa123.jpg";